// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProp } from "@insite/mobius/utilities";
import { logoLinksSearchStyles } from "@west/Overrides/Widgets/Header/LogoLinksSearch";
import { DivWrapper } from "@west/XDL/constants";
import Close from "@west/XDL/Icons/Close";
import Search from "@west/XDL/Icons/Search";
import { color, hideElement, layoutContainer, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

logoLinksSearchStyles.container = {
    css: css`
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 10px;
        padding-bottom: 10px;
        gap: 16px;

        ${layoutContainer};

        ${({ isCheckoutPages }: any) =>
            isCheckoutPages &&
            css`
                .home-page-link {
                    img {
                        max-width: 113px;
                        max-height: 40px;
                    }
                }
            `};
    `,
};

logoLinksSearchStyles.logoWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 16px;
    `,
};

logoLinksSearchStyles.hiddenZipCode = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        margin-left: 24px;

        &:before {
            content: "";
            width: 2px;
            height: 100%;
            background: ${color("common.border")};
            position: absolute;
            left: -20px;
        }

        ${xScreen("lt", "sm")} {
            ${hideElement}
        }
    `,
};

logoLinksSearchStyles.searchMenuWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 543px;
        flex-grow: 1;
        flex-shrink: 1;

        ${xScreen("lte", "sm")} {
            max-width: 297px;
        }
        ${xScreen("lte", 600)} {
            display: none;
        }
    `,
};

logoLinksSearchStyles.actionWrapper = {
    css: css`
        display: flex;
        align-items: center;
        height: 50px;

        & > ${DivWrapper}:nth-child(2) {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 28px;
            margin-right: 30px;
            padding-right: 30px;
            position: relative;
            height: 100%;

            &:empty {
                display: none;
            }
            &:after {
                content: "";
                position: absolute;
                background: ${color("common.border")};
                height: 100%;
                width: 1px;
                right: 0;
                top: 0;
                bottom: 0;
            }
        }
        & > ${DivWrapper}:nth-child(3) {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 28px;
        }

        ${xScreen("lte", "md")} {
            height: auto;
            min-height: 40px;
            & > ${DivWrapper}:nth-child(2) {
                margin-right: 24px;
                padding-right: 0;
                &:after {
                    display: none;
                }
            }
            & > ${DivWrapper}:nth-child(3) {
                gap: 24px;
            }
        }
    `,
};

logoLinksSearchStyles.headerClickableStyles = {
    icon: {
        src: Search,
    },
    clickable: {
        css: css`
            margin-right: 24px;
            ${xScreen("gt", 600)} {
                ${hideElement}
            }
        `,
    },
};

logoLinksSearchStyles.tabletSearchContainer = {
    css: css`
        display: flex;
        gap: 32px;
        align-items: center;
        width: 100%;
    `,
};

logoLinksSearchStyles.mobileCloseSearchIcon = {
    src: Close,
    size: 16,
    color: "common.ui7",
    css: css`
        cursor: pointer;
        &:hover {
            color: ${color("common.ui6")};
        }
    `,
};
